import { useLazyQuery, useQuery } from "@apollo/client";
import { REPORTS } from "../report.queries";
import { ReportsQuery, ReportsQueryVariables } from "../../../__generated__/ReportsQuery";

export const useReports = (variables: ReportsQueryVariables) => {
  return useQuery<ReportsQuery, ReportsQueryVariables>(REPORTS, { variables });
};

export const useLazyReports = () => {
  return useLazyQuery<ReportsQuery, ReportsQueryVariables>(REPORTS);
};
